import { Category, Computer, Forum, Inventory, LocalOffer, Person, Storefront } from "@mui/icons-material"
import { AccountantRoleId, AdminRoleId, MarketingManagerRoleId, OrderManagerRoleId, ProductManagerRoleId } from "utils"

// *Roles IDs
// 0 and 1 for Admin
// 2 for Product Manger
// 3 for Accountant
// 4 for Marketing Manager
// 5 for Order Manager

const Navigations = [
  {
    label: 'Dashboard',
    icon: <Computer />,
    alertTypes: [],
    path: '/'
  },
  {
    label: 'Product Management',
    role: [0, AdminRoleId, ProductManagerRoleId],
    icon: <Storefront />,
    alertTypes: [],
    children: [
      {
        label: 'Tags',
        icon: <LocalOffer />,
        alertTypes: [],
        path: '/product-management/tags'
      },
      {
        label: 'Types',
        icon: <Inventory />,
        alertTypes: [],
        path: '/product-management/types'
      },
      {
        label: 'Variations',
        icon: <Storefront />,
        alertTypes: [],
        path: '/product-management/variations'
      },
      {
        label: 'Categories',
        icon: <Category />,
        alertTypes: [],
        path: '/product-management/categories'
      },
      {
        label: 'Subcategories',
        icon: <Category />,
        alertTypes: [],
        path: '/product-management/subcategories'
      },
      {
        label: 'Products',
        icon: <Category />,
        alertTypes: [],
        path: '/product-management/products'
      },
      {
        label: 'Featured Products',
        icon: <Category />,
        alertTypes: [],
        path: '/product-management/featured-products'
      },
      {
        label: 'Product Approvals',
        icon: <Category />,
        alertTypes: [],
        path: '/product-management/product-approvals'
      },
      {
        label: 'Banned Products',
        icon: <Category />,
        alertTypes: [],
        path: '/product-management/banned-products'
      },
    ]
  },
  {
    label: 'Order Management',
    role: [0, AdminRoleId, OrderManagerRoleId],
    icon: <Inventory />,
    alertTypes: ['newOrderAlert', 'orderPlaced'],
    children: [
      {
        label: 'Orders',
        icon: <Inventory />,
        alertTypes: ['newOrderAlert', 'orderPlaced'],
        path: '/order-management/orders'
      },
      {
        label: 'Cancel Orders',
        icon: <Inventory />,
        alertTypes: [],
        path: '/order-management/cancel-orders'
      },
    ]
  },
  {
    label: 'Payment Management',
    role: [0, AdminRoleId, AccountantRoleId],
    icon: <Storefront />,
    alertTypes: ['paymentDueReminder', 'paymentNotification'],
    children: [
      {
        label: 'Payment Requests',
        icon: <LocalOffer />,
        alertTypes: [],
        path: '/payment-management/payment-requests'
      },
      {
        label: 'Buyer To Admin Payment',
        icon: <LocalOffer />,
        alertTypes: [],
        path: '/payment-management/buyer-admin-payments'
      },
      {
        label: 'Admin To Seller Payment',
        icon: <LocalOffer />,
        alertTypes: [],
        path: '/payment-management/admin-seller-payments'
      },
      {
        label: 'Receivables',
        icon: <LocalOffer />,
        alertTypes: [],
        path: '/payment-management/receivables'
      },
    ]
  },
  {
    label: 'User Management',
    role: [0, AdminRoleId, ProductManagerRoleId],
    icon: <Storefront />,
    alertTypes: [],
    children: [
      {
        label: 'Admin Users',
        role: [0, AdminRoleId],
        icon: <LocalOffer />,
        alertTypes: [],
        path: '/user-management/users'
      },
      {
        label: 'Manufacturers',
        icon: <LocalOffer />,
        alertTypes: [],
        path: '/user-management/manufacturers'
      },
      {
        label: 'Drop Shipper',
        icon: <LocalOffer />,
        alertTypes: [],
        path: '/user-management/dropshippers'
      },
      {
        label: 'Suppliers',
        icon: <LocalOffer />,
        alertTypes: [],
        path: '/user-management/suppliers'
      },
      {
        label: 'Guest Buyers',
        icon: <LocalOffer />,
        alertTypes: [],
        path: '/user-management/guest-buyers'
      },
      {
        label: 'Users Membership',
        icon: <LocalOffer />,
        alertTypes: [],
        path: '/user-management/users-membership'
      },
    ]
  },
  {
    label: 'Tax Management',
    role: [0, AdminRoleId, AccountantRoleId],
    icon: <Storefront />,
    alertTypes: [],
    children: [
      // {
      //   label: 'Vat',
      //   icon: <Storefront />,
      //   alertTypes: [],
      //   path: '/tax-management/vat'
      // },
      {
        label: 'Tax Types',
        icon: <LocalOffer />,
        alertTypes: [],
        path: '/tax-management/tax-types'
      }
    ]
  },
  {
    label: 'Fulfillment',
    role: [0, AdminRoleId, OrderManagerRoleId],
    icon: <Storefront />,
    alertTypes: [],
    children: [
      {
        label: 'Products',
        icon: <Inventory />,
        alertTypes: [],
        path: '/fulfillment/products'
      },
      {
        label: 'Orders',
        icon: <Inventory />,
        alertTypes: [],
        path: '/fulfillment/orders'
      },
    ]
  },
  {
    label: 'Refund and Return',
    role: [0, AdminRoleId, OrderManagerRoleId],
    icon: <Storefront />,
    alertTypes: [],
    path: '/refund-return'
  },
  {
    label: 'Brand Management',
    role: [0, AdminRoleId, MarketingManagerRoleId],
    icon: <Storefront />,
    alertTypes: [],
    path: '/brand-management'
  },
  {
    label: 'Email Marketing',
    role: [0, AdminRoleId, MarketingManagerRoleId],
    icon: <Storefront />,
    alertTypes: [],
    path: '/email-marketing'
  },
  {
    label: 'Commission',
    role: [0, AdminRoleId, AccountantRoleId],
    icon: <Storefront />,
    alertTypes: [],
    path: '/commission'
  },
  {
    label: 'Sales',
    role: [0, AdminRoleId, AccountantRoleId],
    icon: <Storefront />,
    alertTypes: [],
    path: '/sales'
  },
  {
    label: 'Revenues',
    role: [0, AdminRoleId, AccountantRoleId],
    icon: <Storefront />,
    alertTypes: [],
    path: '/revenues'
  },
  {
    label: 'Vouchers',
    role: [0, AdminRoleId, ProductManagerRoleId],
    icon: <Storefront />,
    alertTypes: [],
    path: '/vouchers'
  },
  {
    label: 'Sale Management',
    role: [0, AdminRoleId, ProductManagerRoleId],
    icon: <Storefront />,
    alertTypes: ['flashSaleAlert'],
    children: [
      {
        label: 'Campaigns',
        icon: <LocalOffer />,
        alertTypes: [],
        path: '/sale-management/campaigns'
      },
      {
        label: 'Flash Sales',
        icon: <Inventory />,
        alertTypes: ['flashSaleAlert'],
        path: '/sale-management/flash-sales'
      },
    ]
  },
  {
    label: 'Invoice Management',
    role: [0, AdminRoleId, AccountantRoleId],
    icon: <Inventory />,
    alertTypes: [],
    path: '/invoice-management'
  },
  {
    role: [0, AdminRoleId, MarketingManagerRoleId],
    label: 'Promotions',
    icon: <Inventory />,
    alertTypes: [],
    path: '/promotions'
  },
  {
    label: 'Courier Management',
    role: [0, AdminRoleId, OrderManagerRoleId],
    icon: <Inventory />,
    alertTypes: [],
    path: '/courier-management'
  },
  // {
  //   label: 'Website Management',
  //   role: [0, AdminRoleId],
  //   icon: <Inventory />,
  //   alertTypes: [],
  //   path: '/website-management'
  // },
  {
    label: 'Subscribers',
    role: [0, AdminRoleId, MarketingManagerRoleId],
    icon: <Inventory />,
    alertTypes: [],
    path: '/subscribers'
  },
  {
    label: 'Contact Records',
    role: [0, AdminRoleId, ProductManagerRoleId],
    icon: <Inventory />,
    alertTypes: [],
    path: '/contact-records'
  },
  {
    role: [0, AdminRoleId, MarketingManagerRoleId],
    label: 'Chat',
    icon: <Forum />,
    alertTypes: ['newChatAlert'],
    path: '/chat'
  },
  {
    label: 'Profile',
    icon: <Person />,
    alertTypes: [],
    path: '/profile'
  },
]

export default Navigations